'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = Brick;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./brick.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Brick(props) {
	var _props$background = props.background,
	    background = _props$background === undefined ? '' : _props$background,
	    _props$size = props.size,
	    size = _props$size === undefined ? 100 : _props$size,
	    _props$className = props.className,
	    className = _props$className === undefined ? '' : _props$className,
	    children = props.children;


	var inlineStyles = {
		background: background
	};

	var cubeStyles = {
		width: size + 'px',
		height: size + 'px'
	};

	return _react2.default.createElement(
		'div',
		{ className: 'cube ' + className, style: cubeStyles },
		_react2.default.createElement('div', { className: 'cubeFace front', style: Object.assign({}, inlineStyles, {
				transform: 'rotateY(0deg) translateZ(' + size / 2 + 'px)'
			}) }),
		_react2.default.createElement('div', { className: 'cubeFace back', style: Object.assign({}, inlineStyles, {
				transform: 'rotateY(180deg) translateZ(' + size / 2 + 'px)'
			}) }),
		_react2.default.createElement('div', { className: 'cubeFace right', style: Object.assign({}, inlineStyles, {
				transform: 'rotateY(90deg) translateZ(' + size / 2 + 'px)'
			}) }),
		_react2.default.createElement('div', { className: 'cubeFace left', style: Object.assign({}, inlineStyles, {
				transform: 'rotateY(-90deg) translateZ(' + size / 2 + 'px)'
			}) }),
		_react2.default.createElement(
			'div',
			{ className: 'cubeFace top', style: Object.assign({}, inlineStyles, {
					transform: 'rotateX( 90deg) translateZ(' + size / 2 + 'px)'
				}) },
			children
		),
		_react2.default.createElement('div', { className: 'cubeFace bottom', style: Object.assign({}, inlineStyles, {
				transform: 'rotateX(-90deg) translateZ(' + size * 0.8 / -2 + 'px)'
			}) })
	);
}

//# sourceMappingURL=brick.jsx.map